<template>
  <Transition name="fade" mode="out-in">
    <div id="logoContainer" v-if="isDesktop">
      <img id="logo" src="./assets/img/logo.png" />
    </div>
  </Transition>
  <Navbar />
  <Transition name="fade" mode="out-in">
    <div id="appContent" v-if="loadDetails">
      <Transition name="fade" mode="out-in">
        <div id="detailsBanner" v-if="currentView === 'welcome'">
          {{`Welcome${ currentUser ? (', ' + (currentUser.userType === 'Individual' ? currentUser.firstName : (currentUser.firstName + ' ' + currentUser.lastName))) : ''}`}}
        </div>
        <div id="detailsBanner" v-else-if="currentView === 'gameover'">
          {{ ((currentRound === rounds.length - 1) ? 'Game Over' : 'End of Round') }}
        </div>
      </Transition>
      <Transition name="fade" mode="out-in">
        <Welcome v-if="currentView === 'welcome'" />
        <!-- <Instructions v-else-if="currentView === 'instructions'" /> -->
        <Question v-else-if="currentView === 'question'" />
        <GameOver v-else-if="currentView === 'gameover'" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <LoginModal v-if="showLoginModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <LogoutModal v-if="showLogoutModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <LeaderboardModal v-if="showLeaderboardModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <HelpModal v-if="showHelpModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <UserModal v-if="showUserModal" />
      </Transition>
      <Transition name="fade" mode="out-in">
        <ErrorModal v-if="showErrorModal" />
      </Transition>
    </div>
  </Transition>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import Welcome from './views/Welcome.vue'
import GameOver from './views/GameOver.vue'
import Question from './views/Question.vue'
import LoginModal from './components/LoginModal.vue'
import LogoutModal from './components/LogoutModal.vue'
import HelpModal from './components/HelpModal.vue'
import UserModal from './components/UserModal.vue'
import LeaderboardModal from './components/LeaderboardModal.vue'
import ErrorModal from './components/ErrorModal.vue'
import Navbar from './components/Navbar.vue'
import { mapGetters, mapActions } from 'vuex'
import { onValue } from 'firebase/database'

export default {
  name: 'App',
  components: {
    Welcome,
    GameOver,
    Question,
    LoginModal,
    LogoutModal,
    LeaderboardModal,
    HelpModal,
    UserModal,
    ErrorModal,
    Navbar,
  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'users',
      'currentUser',
      'currentQuestionID',
      'currentView',
      'currentRound',
      'showLeaderboardModal',
      'showHelpModal',
      'showLoginModal',
      'showLogoutModal',
      'showUserModal',
      'showErrorModal',
      'usersRef',
      'roundsRef',
      'unlockedRef',
      'rounds',
      'clientWidth',
      'breakpoints',
    ]),
    isDesktop(){
      const theApp = this;
      return (theApp.clientWidth > theApp.breakpoints.tab);
    },
  },
  methods: {
    ...mapActions([
      'onResize',
      'login',
      'logout',
      'updateUsers',
      'updateRounds',
      'updateCurrentRound',
      'updateCurrentView',
      'updateCurrentQuestionID',
      'toggleErrorModal',
      'toggleErrorModalLock',
      'updateErrorMessage',
      'updateLockedStatus',
    ]),
    // loadQuestion(scannedContent){
    //   const theApp = this;
    //   if(theApp.showReader && theApp.cameraPermissionGranted){
    //     let questionList = theApp.currentUser.questions.map(question => question.masterQuestionID);
    //     let potentialQuestionNumber = parseInt(scannedContent);
    //     let matchingUserQuestion = theApp.currentUser.questions.find(userQuestion => userQuestion.userQuestionID === (potentialQuestionNumber - 1));

    //     // if scanned content is valid question number and an unanswered question, load it
    //     if(questionList.includes((potentialQuestionNumber - 1)) && matchingUserQuestion && !theApp.currentUser.completedQuestions.includes(matchingUserQuestion.masterQuestionID)){
    //       theApp.toggleReaderVisibility(false);
    //       // reduce by 1 since question ID is 0 based
    //       theApp.updateCurrentQuestionID((potentialQuestionNumber - 1));
    //       theApp.updateCurrentView('question');
    //     }else{
    //       // otherwise show error & close scanner
    //       if(questionList.includes((potentialQuestionNumber - 1))){
    //         theApp.updateErrorMessage('You\'ve already answered this question!')
    //         theApp.toggleErrorModal()
    //       }else{
    //         console.log(scannedContent)
    //         theApp.updateErrorMessage(`This doesn’t appear to be a valid code for this activity.<br/>The scanned content was: ${scannedContent}`)
    //         theApp.toggleErrorModal()
    //       }
    //       theApp.toggleReaderVisibility(false);
    //     }
    //   }
    // }
  },
  mounted(){
    const theApp = this;
    window.quizWhizApp = this;
    document.title = theApp.moduleTitle.replace(/<[^>]*>?/gm, '');

    // set up resize listener
    theApp.$nextTick(() => {
      window.addEventListener('resize', theApp.onResize);
    });

    // set up listener for users 
    onValue(theApp.usersRef, (snapshot) => {
      if(snapshot.val()){
        let updatedUsers = Object.entries(snapshot.val()).map(entry => {
          return {
            ...entry[1],
            id: entry[0],
            questions: entry[1].questions ? Object.entries(entry[1].questions).map(questionEntry => {
              return {
                ...questionEntry[1],
                questionRefID: questionEntry[0]
              }
            }) : [],
            viewedQuestions: entry[1].viewedQuestions ? Object.values(entry[1].viewedQuestions) : [],
            completedQuestions: entry[1].completedQuestions ? Object.values(entry[1].completedQuestions) : [],
            completedRounds: entry[1].completedRounds ? Object.values(entry[1].completedRounds) : [],
          }
        });
        theApp.updateUsers(updatedUsers)
      }else{
        theApp.updateUsers([])
      }
    })

    // set up listener for rounds 
    onValue(theApp.roundsRef, (snapshot) => {
      if(snapshot.val()){
        let updatedRounds = Object.entries(snapshot.val()).map(entry => {
          return {
            ...entry[1]
          }
        });
        theApp.updateRounds(updatedRounds)

        // default to last round
        let curRound = (updatedRounds.length - 1);
        let curTime = Math.floor(Date.now() / 1000)

        // overwrite current round if we find something that better matches the expected timeframes
        updatedRounds.forEach(round => {
          if(curTime >= round.startTime && curTime <= round.endTime){
            curRound = round.id;
          }
        })

        theApp.updateCurrentRound(curRound);

        if(theApp.currentUser){
          let userCompletedRound = true;
          let roundQuestionIDs = theApp.currentUser.questions.filter(question => question.roundID === theApp.currentRound).map(question => question.masterQuestionID)
          roundQuestionIDs.forEach(questionID => {
            if(!theApp.currentUser.completedQuestions.includes(questionID)){
              userCompletedRound = false;
            }
          })
          // if user hasn't completed round, kick back to home view
          if(!userCompletedRound){
            theApp.updateCurrentView('welcome');
          }else{ //otherwise send them to the game/round over view
            theApp.updateCurrentView('gameover');
          }
        }else{
          theApp.updateCurrentView('welcome');
        }


        theApp.loadDetails = true;
      }else{
        theApp.updateRounds([])
        theApp.updateCurrentRound(null)
      }
    })

    // set up listener for game being unlocked 
    onValue(theApp.unlockedRef, (snapshot) => {
      theApp.updateLockedStatus(snapshot.val())
    })
  },
  beforeUnmount(){
    const theApp = this;
    window.removeEventListener('resize', theApp.onResize);
  },
  data(){
    return {
      loadDetails: false,
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<style>
  #logoContainer{
    position: absolute;
    right: 10px;
    top: 20px;
  }

  #logo{
    width: 125px;
    height: auto;
  }

  #appContent{
    width: 100%;
    height: calc(100vh - 150px);
    margin: 0 auto;
/*    padding: 30px 0px;*/
    position: fixed;
    left: 0;
    right: 0;
    top: 150px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: rgba(0,0,0,.65);
    line-height: 1.3em;
    z-index: 51; /* MAY BE ABLE TO REMOVE THIS WHEN CHANGING NAVBAR DISPLAY TO HAMBURGER MENU ON SMALLER VIEWPORTS */
  }

  #detailsBanner{
    font-size: 24px;
    font-weight: bold;
    padding: 10px 0px;
    max-height: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

/*  @media screen and (max-width: 496px){
    #appContent{
      width: 90%;
    }
  }*/

  @media screen and (max-width: 1023px){
    #appContent{
      height: calc(100vh - 100px);
      top: 100px;
    }
  }
</style>